export default __webpack_public_path__ + "static/media/bv_thumbnail.3dbc16af.png";